import { useEffect } from 'react'

interface PageMeta {
  title: string
  description: string
  canonical: string
  robots?: string
}

const SITE_ORIGIN = 'https://www.robertsonprecision.com'

function setMetaByName(name: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setMetaByProperty(property: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('property', property)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function usePageMeta({
  title,
  description,
  canonical,
  robots = 'index,follow',
}: PageMeta): void {
  useEffect(() => {
    document.documentElement.lang = 'en-US'
    document.title = title
    setMetaByName('description', description)
    setMetaByName('robots', robots)
    setMetaByProperty('og:type', 'website')
    setMetaByProperty('og:site_name', 'Robertson Precision')
    setMetaByProperty('og:title', title)
    setMetaByProperty('og:description', description)
    setMetaByProperty('og:url', canonical)

    let link = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    )
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
    }
    link.setAttribute('href', canonical)
  }, [title, description, canonical, robots])
}

export function canonicalFor(path: string): string {
  return `${SITE_ORIGIN}${path}`
}
